<template>
  <div class="darwin-avatar">
    <ToolTip
      :content="hasTooltip ? name : undefined"
      :delay="[500, 500]"
      placement="right"
      use-portal
    >
      <img
        v-if="url"
        :key="url"
        :src="url"
        :alt="name"
        :height="size"
        :width="size"
        role="img"
        :aria-label="`Avatar of the member ${name}`"
        class="darwin-avatar__icon"
      />
      <div
        v-else
        class="darwin-avatar__initials"
        :style="{ background: avatarColor }"
      >
        <svg viewBox="0 0 100 100">
          <text
            x="50%"
            y="50%"
            fill="currentColor"
            font-size="46"
            text-anchor="middle"
            dominant-baseline="central"
          >
            {{ initials }}
          </text>
        </svg>
      </div>
    </ToolTip>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getColorHash } from '@/uiKit/colorPalette'
import { getShortenedName } from '@/core/utils/formatter'
import ToolTip from '@/uiKit/ToolTip/ToolTip.vue'

const props = withDefaults(
  defineProps<{
    id: number
    hasTooltip?: boolean
    name?: string
    size?: number
    url?: string | null
  }>(),
  { hasTooltip: true, name: undefined, size: 20, url: null },
)

const avatarColor = computed(() => getColorHash(`${props.id || ''}${props.name?.trim()}`))

const initials = computed(() => getShortenedName(`${props.name?.trim()}`))

const avatarSize = computed(() => `${props.size}px`)
</script>

<style lang="scss" scoped>
.darwin-avatar {
  position: relative;
  height: v-bind(avatarSize);
  width: v-bind(avatarSize);

  &__icon,
  &__initials {
    grid-row: 1;
    grid-column: 1;
    height: 100%;
    width: 100%;
    border-radius: 50%;
    display: grid;
    align-items: center;
    justify-content: center;
    @include noSelect;
  }

  &__initials {
    svg {
      height: 100%;
      width: 100%;
    }

    text {
      fill: $colorWhite;
    }
  }
}
</style>
